"use client";
import React from "react";
import Button from "../../../ui/Button";
import { ButtonControls } from "../../design2/components/SimilarPosts2";
import { AnnouncementCard } from "./Announcements";
import { Announcement } from "./Announcements";
import { useCarouselAnnouncements } from "src/app/lib/useCarouselAnnouncement";

// Sample announcement data (replace with your actual data)

const SimilarPosts3: React.FC<{
  header?: React.ReactNode;
  arr?: Announcement[];
  secondary?: boolean;
}> = ({ arr, secondary }) => {
  const { emblaRef, canScrollPrev, canScrollNext, emblaApi, announcements } =
    useCarouselAnnouncements();

  const dataToMap = secondary ? arr : announcements;
  if (dataToMap?.length === 0) return null;

  return (
    <section className="py-5 mt-10 pb-14 ">
      <div className="mx-auto">
        <h3>Related Posts</h3>
        <div className="relative mt-4">
          {/* Custom Prev Button */}
          <button
            className={`absolute rotate-180  top-[25%] z-10 ${
              canScrollPrev ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollPrev()}
          >
            <ButtonControls />
          </button>
          {/* Embla Carousel */}
          <div className="w-full">
            <div className="embla overflow-hidden" ref={emblaRef}>
              <div className="embla__container relative items-stretch flex">
                {dataToMap?.map((announcement, index) => (
                  <div
                    className="embla__slide w-auto select-none pr-8 shrink-0"
                    key={index}
                  >
                    <AnnouncementCard {...announcement} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <button
            className={`absolute top-[25%] right-4 transform  z-10  ${
              canScrollNext ? "visible" : "invisible"
            }`}
            onClick={() => emblaApi && emblaApi.scrollNext()}
          >
            <ButtonControls />
          </button>
        </div>

        <Button
          href="/announcements"
          className="w-max mx-auto primary-btn px-8 py-3 block mt-12"
        >
          Explore More
        </Button>
      </div>
    </section>
  );
};
export default SimilarPosts3;
